import React from 'react'

import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined'
import { blue, brown, grey, lightGreen, lime, purple, teal } from '@mui/material/colors'

export type FeatureGroupId =
  | 'limits'
  | 'contacts'
  | 'products'
  | 'connectors'
  | 'connectorBehaviour'
  | 'other'
  | 'retired'

export type FeatureGroup = {
  id: FeatureGroupId
  title: string
  startsOpen: boolean
  icon: React.ReactNode
  // Hues at 216, 173, 282, 95, 54 and 15 degrees - every pair at least 39 apart, which is what stops
  // two panels reading as the same colour. Eyeballing this went wrong twice: indigo[900] turned out
  // to be primary's exact hue, and blue[900] sat 19 degrees off it. A test measures the distances now
  // and also refuses any exact palette main, since those already mean something here.
  color: string
}

// Order, titles, icons and what starts collapsed. Which features belong to a group is declared beside
// the feature in FEATURES; `other` catches keys real customers hold that nothing declares.
export const FEATURE_GROUPS: FeatureGroup[] = [
  {
    id: 'limits',
    title: 'Limits',
    startsOpen: true,
    icon: <BarChartOutlinedIcon fontSize="small" />,
    color: blue[900],
  },
  {
    id: 'contacts',
    title: 'Contacts',
    startsOpen: true,
    icon: <ContactsOutlinedIcon fontSize="small" />,
    color: teal[700],
  },
  {
    id: 'products',
    title: 'Products',
    startsOpen: true,
    icon: <WidgetsOutlinedIcon fontSize="small" />,
    color: purple[700],
  },
  {
    id: 'connectors',
    title: 'Integrations & Connectors',
    startsOpen: true,
    icon: <HubOutlinedIcon fontSize="small" />,
    color: lightGreen[800],
  },
  {
    id: 'connectorBehaviour',
    title: 'Connector behaviour',
    startsOpen: true,
    icon: <AccountTreeOutlinedIcon fontSize="small" />,
    color: lime[900],
  },
  {
    id: 'other',
    title: 'Other',
    startsOpen: true,
    icon: <HelpOutlineOutlinedIcon fontSize="small" />,
    color: grey[600],
  },
  {
    id: 'retired',
    title: 'Not in use',
    startsOpen: false,
    icon: <ArchiveOutlinedIcon fontSize="small" />,
    color: grey[400],
  },
]

// Not a feature group: these are lines on this screen, so they get their own panel.
export const QUOTAS_PANEL = {
  id: 'quotas',
  title: 'API quotas',
  startsOpen: true,
  icon: <ApiOutlinedIcon fontSize="small" />,
  color: brown[600],
}
